<template lang="pug">
.k-hero.hero(
  :class='classes'
  :style='background'
)
  transition( :name='transition' mode='out-in' appear )
    component(
      :is='heroComponent'
      :key='heroKey'
      :class='classes'
      v-bind='heroData'
    )
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
// import { Logger } from '@/lib/logger'
import { heros, components } from './heros'

export default {
  name: 'HeroBlock',
  mixins: [],
  components: { ...components },
  props: {
    title: {
      type: String,
      default: ''
    },
    interval: {
      type: Number,
      default: 15000
    },
    autoplayTimeout: {
      type: Number,
      default: 15000
    },
  },
  data() {
    return {
      heros,
      loading: true,
      goto: 0,
      slide: 0,
      sliding: null,
      players: {},
      played: {},
      ready: {},
      waiting: {},
      playing: {},
      currentPlaying: false,
      trying: null
    }
  },
  created() {},
  mounted() {
  },
  updated() {
  },
  methods: {
    ...mapActions([ 'updateHeroData' ]),
  },
  computed: {
    ...mapState([ 'hero' ]),
    name() {
      return ( this.hero && this.hero.name ) || 'default'
    },
    heroData() {
      return ( this.hero && this.hero.data ) || {}
    },
    heroId() {
      return ( this.heroData && this.heroData.id ) || ''
    },
    heroType() {
      return this.heros[ this.name ] && this.heros[ this.name ].meta.type
    },
    heroComponent() {
      return this.heros[ this.name ] && this.heros[ this.name ].component
    },
    heroKey() {
      return `${this.name}-${this.heroId}`
    },
    fullscreen() {
      return !this.hero ||
         ( this.heros[ this.name ] && this.heros[ this.name ].meta.fullscreen )
    },
    classes() {
      return { fullscreen: this.fullscreen }
    },
    transition() {
      return 'fade-slow'
    },
    background() {
      return 'transparent'
    },
  },
  watch: {
    goto( slide ) {
      this.pageChanged( slide )
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.k-hero {
  position: relative;
  height: 30vh;
  @include for-mobile {
    height: 40vh;
  }
  @include for-desktop {
    &.fullscreen {
      height: 100vh;
    }
  }
}
</style>
